import fr from './fr.json';

export const locales = {
  fr,
};
